import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';

import { LibraryUrlSearchParams, Routes } from '@/constants';
import { Link } from '@/containers';
import { useEpisodeCategories } from '@/hooks';
import { useFetchLibraryCategoriesQuery } from '@/store';
import { Episode } from '@/types';

const getLibraryRoute = (categorySlug?: string, subCategorySlug?: string) => {
  if (!categorySlug) return undefined;

  const searchParams = new URLSearchParams();
  searchParams.set(LibraryUrlSearchParams.CATEGORY_SLUG, categorySlug);
  if (subCategorySlug) {
    searchParams.set(LibraryUrlSearchParams.SUB_CATEGORY_SLUG, subCategorySlug);
  }
  return { pathname: Routes.LIBRARY, search: searchParams.toString() };
};

export const EpisodeCategories = ({ episode }: { episode: Episode }) => {
  const categoriesString = useEpisodeCategories(episode);
  const { data: libraryCategories } = useFetchLibraryCategoriesQuery();

  if (!categoriesString) {
    return null;
  }

  const categories = categoriesString
    .split(', ')
    .filter(Boolean)
    .map(label => {
      const [categoryName, subCategoryName] = label.split(': ');
      const category = Object.values(libraryCategories?.entities ?? {}).find(
        ({ name }) => name === categoryName,
      );
      const subCategory = Object.values(
        category?.subCategories.entities ?? {},
      ).find(({ name }) => name === subCategoryName);

      return { label, to: getLibraryRoute(category?.slug, subCategory?.slug) };
    });

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Categories
      </Typography>
      <Typography variant="body3">
        {categories.map(({ label, to }, index) => (
          <Fragment key={label}>
            {index > 0 && ', '}
            <Link to={to} inline>
              {label}
            </Link>
          </Fragment>
        ))}
      </Typography>
    </Box>
  );
};
